/* eslint-disable class-methods-use-this */
import Vue from 'vue';
import GstplnApp, { GstplnAppCategory } from '../app';

export default class MewsApp extends GstplnApp {
  constructor(vue: Vue) {
    super(vue, 'app.mews', {
      categories: [GstplnAppCategory.Integrations],
      hasDarkIcon: true,
      underPaywall: true,
      configComponentImportFnc: () => import('@/components/apps/mews/SettingsDialog.vue'),
    });
  }
}
